// helpers
import NFA from 'shared/helpers/analytics/NFAnalytics';

// constants
import { PAGE_TYPE, EVENTS } from 'shared/helpers/DTM';
import { DEFAULT_CHANNEL } from 'shared/helpers/DTM/constants';
import { TRACK_TYPE } from 'shared/helpers/analytics/constants';
import { NLP_EVENTS } from 'shared/helpers/analytics/constants/nlp';

const CHANNEL = DEFAULT_CHANNEL;
const OFFER_PAGE_PATH = '/offer.html';

const checkIsOfferPage = () => {
  return document.location.pathname === OFFER_PAGE_PATH;
};

export const onPageLoad = (NDNPageType: string) => {
  const isOfferPage = checkIsOfferPage();

  const data: { [key: string]: string | boolean } = {};

  if (isOfferPage) {
    data.pagetype = PAGE_TYPE.OFFERPAGE;
    data.eventName = EVENTS.OFFERPAGE;
    data.pagename = `${CHANNEL} : ${PAGE_TYPE.OFFERPAGE}`;
  } else {
    data.pagetype = PAGE_TYPE.LANDINGPAGE;
    data.eventName = EVENTS.LANDINGPAGE;
    data.pagename = `${CHANNEL} : ${PAGE_TYPE.LANDINGPAGE}`;
  }

  data.NDNPageType = NDNPageType;

  data.channel = CHANNEL;
  // DTM.onPageLoad(data);

  NFA.track({
    type: TRACK_TYPE.PAGELOAD,
    event: NLP_EVENTS.NLP_PAGELOAD,
    data: { page: NDNPageType },
    dtmData: data,
  });
};
